// auth.js
export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const UPDATE_USER = 'UPDATE_USER'
export const SAVE_ADMIN_ID = 'SAVE_ADMIN_ID'

//dashboard.js

export const GET_DASHBOARD = 'GET_DASHBOARD'
export const GET_DASHBOARD_FAILURE = 'GET_DASHBOARD_FAILURE'
export const RESET_DASHBOARD = 'RESET_DASHBOARD'

//devices.js

export const GET_DEVICES = 'GET_DEVICES'
export const GET_DEVICES_FAILURE = 'GET_DEVICES_FAILURE'
export const RESET_DEVICES = 'RESET_DEVICES'


//invoices.js

export const LOAD_INVOICES = 'LOAD_INVOICES'
export const GET_INVOICES = 'GET_INVOICES'
export const GET_INVOICES_FAILURE = 'GET_INVOICES_FAILURE'
export const GET_DATE = 'GET_DATE'

//invoicesId.js

export const GET_INVOICE_ID = 'GET_INVOICE_ID'
export const GET_INVOICE_ID_FAILURE = 'GET_INVOICE_ID_FAILURE'
export const SET_INVOICE_LOADING_STATE_TRUE = 'SET_INVOICE_LOADING_STATE_TRUE'

//billing-info.js

export const FETCH_BILLING_INFO_SUCCESS = 'FETCH_BILLING_INFO_SUCCESS'
export const FETCH_BILLING_INFO_FAILURE = 'FETCH_BILLING_INFO_FAILURE'

//request_a_site.js

export const FETCH_REQUEST_A_SITE_IP_SUCCESS = 'FETCH_REQUEST_A_SITE_IP_SUCCESS'
export const FETCH_REQUEST_A_SITE_IP_FAILURE = 'FETCH_REQUEST_A_SITE_IP_FAILURE'

//tickets.js

export const CLEAR_TICKET = 'CLEAR_TICKET';
export const START_FETCH_TICKETS = 'START_FETCH_TICKETS';
export const START_FETCH_TICKET = 'START_FETCH_TICKET';
export const FETCH_TICKETS_SUCCESS = 'FETCH_TICKETS_SUCCESS';
export const FETCH_TICKET_SUCCESS = 'FETCH_TICKET_SUCCESS';
export const FETCH_TICKETS_FAILURE = 'FETCH_TICKETS_FAILURE';
export const FETCH_TICKET_FAILURE = 'FETCH_TICKET_FAILURE';

// lang.js
export const SET_LOCALE = 'SET_LOCALE'


// layout.js
export const CHANGE_SIDEBAR = 'CHANGE_SIDEBAR'



// WEBPACK FOOTER //
// ./resources/assets/js/store/mutation-types.js